function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Man");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M161.3,40c0,10.6-8.6,19.1-19.1,19.1c-10.6,0-19.1-8.6-19.1-19.1s8.6-19.1,19.1-19.1C152.7,20.9,161.3,29.4,161.3,40   L161.3,40z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M172.6,62h-60.8c-6.5,0-11.8,4.3-11.8,9.7l16.1,59.8c0,3.7,2.6,7,6.3,8.6v30.2c0,5.9,4,10.7,8.9,10.7   c4.9,0,8.9-4.8,8.9-10.7v-29.1h4v29.1c0,5.9,4,10.7,8.9,10.7c4.9,0,8.9-4.8,8.9-10.7v-30.2c3.8-1.6,6.3-4.9,6.3-8.6l16.1-59.8   C184.3,66.3,179.1,62,172.6,62z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    version: 1.1,
    viewBox: "0 0 200 200",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Man.f33551a9.svg";
export { SvgComponent as ReactComponent };